import { render } from "./AppFooter.vue?vue&type=template&id=c8fce81c&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=c8fce81c&scoped=true&lang=scss"

import exportComponent from "/Users/phil/Sites/2022lovehate/vue-starter-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8fce81c"]])

export default __exports__